import appConfigManager from '../common/js/FJAppConfigManager.js';
import {
    AI_KEY_TO_AI_TYPE,
    AI_TYPE_IN_MEDIA,
    AI_TYPE_KEY_TO_TEXT_KEY,
    AI_TYPE_TO_TOOL_KEY,
    COMMUNITY_COVER_IMAGE_PATH,
    COMMUNITY_COVER_VIDEO_PATH,
    SUPPORT_COMMUNITY_JOB_TYPE,
    COMMUNITY_WORKS_TYPE,
    COMMUNITY_SORT_TYPE,
} from '../config/dataConfig/FJCommunityData.js';
import FJConstant from '../constants/FJConstant.js';
import FJCommunityUtil from '../util/FJCommunityUtil.js';
import FJUtil from '../util/FJUtil.js';
import FJNetworkStore from './FJNetworkStore.js';

const _getOriginalImages = obj => {
    const { singleImage, startImage, endImage, multiImage, inputImages, referenceImages, originalUrl, effectInfo } =
        obj;
    try {
        if (singleImage) {
            return [singleImage];
        } else if (startImage || endImage) {
            return [startImage, endImage].filter(Boolean);
        } else if (multiImage) {
            return multiImage.filter(Boolean);
        } else if (inputImages) {
            return inputImages.filter(Boolean);
        } else if (referenceImages) {
            return referenceImages.filter(Boolean);
        } else if (originalUrl) {
            return [originalUrl];
        } else if (effectInfo?.effectOriginalUrlList?.length > 0) {
            return effectInfo.effectOriginalUrlList.filter(Boolean);
        }
    } catch (error) {
        console.error(error);
        return [];
    }
    return [];
};
const _getCoverData = str => {
    // return {};
    if (!str) return {};
    const coverInfo = JSON.parse(str);
    return {
        coverImg: COMMUNITY_COVER_IMAGE_PATH + coverInfo?.cover,
        coverVideo: COMMUNITY_COVER_VIDEO_PATH + coverInfo?.video,
    };
};
const _parseMyCreations = async (list, workType = FJConstant.MY_CREATIONS_WORK) => {
    let newList = [];
    const appConfigList = appConfigManager.getAppConfigList();
    for (let idx = 0; idx < list.length; idx++) {
        const item = list[idx];

        const jobType = item.job_type;
        const configInfo = appConfigList.find(info =>
            info.config?.historyListType?.toString().includes(jobType.toString()),
        );
        if (!configInfo) continue;

        const parseList = await FJUtil.parseList([item], {
            type: FJConstant.COMMUNITY,
            resultImageKey: configInfo.config.resultImageKey,
            originalImageKey: configInfo.config.originalImageKey,
            appType: configInfo.type,
        });
        let newItem = parseList[0];
        newItem.mediaType = newItem.videoUrl ? FJConstant.VIDEO : FJConstant.IMAGE;
        newItem.originalImages = _getOriginalImages(newItem);
        newItem.workType = workType;
        newItem.isCurrentUser = FJUtil.getUserId() === newItem.uid;
        newItem.previewType = FJConstant.TOOL_PREVIEW;
        newItem.isSupportCommunity = SUPPORT_COMMUNITY_JOB_TYPE.includes(jobType);
        newItem.communityType = COMMUNITY_WORKS_TYPE.WORKS;

        if (item.cover_info) {
            const coverInfo = _getCoverData(item.cover_info);
            newItem.coverImg = coverInfo?.coverImg;
            newItem.coverVideo = coverInfo?.coverVideo;
        }
        newList.push(newItem);
    }
    return newList;
};

const _parseTemplateWork = async info => {
    if (!info) return {};
    try {
        const { item = '' } = info;
        const { key_name, desc = '', name = '', ratioLists = [], youtube_id = '' } = item || {};
        const currentRatio = ratioLists[0].ratio;
        const imgUrl = FJCommunityUtil.getTemplatePreviewCoverPath(key_name, currentRatio, ratioLists);
        const videoUrl = FJCommunityUtil.getTemplatePreviewVideoPath(key_name, currentRatio, ratioLists, 'MIDDLE');
        const ratioItem = ratioLists.find(item => Math.abs(currentRatio - item.ratio) < 0.02);
        const youtubeId = youtube_id;

        const sceneList = FJCommunityUtil.getTemplatePreviewCoverListPath(key_name, currentRatio, ratioLists);
        const height = 400;
        const width = currentRatio * 400;
        return {
            id: ratioLists[0]?.template_id,
            ratio: currentRatio,
            name,
            key_name,
            youtubeId,
            description: desc,
            imgUrl,
            videoUrl,
            currentId: ratioItem?.template_id,
            sceneList: sceneList,
            workType: FJConstant.TEMPLATE_WORK,
            communityType: COMMUNITY_WORKS_TYPE.TEMPLATE,
            mediaType: FJConstant.VIDEO,
            width,
            height,
        };
    } catch (error) {
        return;
    }
};
const _parseCommunityWorkList = async (list, workType = FJConstant.COMMUNITY_WORK) => {
    let newList = [];
    const appConfigList = appConfigManager.getAppConfigList();
    for (let idx = 0; idx < list.length; idx++) {
        try {
            const item = list[idx];
            if (item.type === COMMUNITY_WORKS_TYPE.ADVERTISING) {
                // 广告
            } else if (item.type === COMMUNITY_WORKS_TYPE.TEMPLATE) {
                // 剪同款
                const templateInfo = await _parseTemplateWork(item);
                if (templateInfo) {
                    newList.push(templateInfo);
                }
            } else {
                const jobType = item.job_type || item.item.job_type;
                const configInfo = appConfigList.find(info =>
                    info.config?.historyListType?.toString().includes(jobType.toString()),
                );
                if (!configInfo || !item.item) {
                    newList.push(null); // 分页计数，前端过滤空数据
                    continue;
                }

                const parseList = await FJUtil.parseList([item.item], {
                    type: FJConstant.COMMUNITY,
                    resultImageKey: configInfo.config.resultImageKey,
                    originalImageKey: configInfo.config.originalImageKey,
                    appType: configInfo.type,
                });
                let newItem = parseList[0];
                newItem.communityType = item.type;
                newItem.communityId = item.id;
                newItem.coverInfo = item.cover_info;
                newItem.avatar = item.avatar;
                newItem.username = item.username;
                newItem.userKey = item.userKey;
                newItem.mediaType = newItem.videoUrl ? FJConstant.VIDEO : FJConstant.IMAGE;
                newItem.originalImages = _getOriginalImages(newItem);
                newItem.workType = workType;
                newItem.isCurrentUser = FJUtil.getUserId() === newItem.uid;
                newItem.previewType =
                    workType === FJConstant.SHARED_WORK && newItem.isCurrentUser
                        ? FJConstant.TOOL_PREVIEW
                        : FJConstant.COMMUNITY_PREVIEW;
                newItem.isSupportCommunity = SUPPORT_COMMUNITY_JOB_TYPE.includes(jobType);
                if (item.cover_info) {
                    const coverInfo = _getCoverData(item.cover_info);
                    newItem.coverImg = coverInfo?.coverImg;
                    newItem.coverVideo = coverInfo?.coverVideo;
                }
                newList.push(newItem);
            }
        } catch (error) {
            console.error(error);
        }
    }

    return newList;
};
const FJCommunityStore = {
    getAppConfigList: () => {
        return appConfigManager.getAppConfigList();
    },
    getCommunityTypes: async () => {
        try {
            const list = await FJNetworkStore.getCommunityTypes();
            if (list) {
                return list;
            }
            return false;
        } catch (error) {
            return false;
        }
    },
    getCommunityList: async (options = {}) => {
        try {
            const {
                start,
                limit,
                type,
                category,
                workType,
                userKey,
                sortType = COMMUNITY_SORT_TYPE[0].value,
            } = options;
            const data = await FJNetworkStore.getCommunityList({ start, limit, type, category, userKey, sortType });
            if (!data || !data.list) return false;
            const { list, has_more: hasMore } = data;
            return {
                list: await _parseCommunityWorkList(list, workType),
                hasMore,
            };
        } catch (error) {
            return false;
        }
    },

    getMyCreationsList: async () => {
        try {
            const { data, code } = await FJNetworkStore.getAICollectionList(AI_TYPE_IN_MEDIA.join(','));
            if (code === 200) {
                const list = [];

                for (const item of data) {
                    list.push({
                        list: await _parseMyCreations(item.list, FJConstant.MY_CREATIONS_WORK),
                        category: AI_TYPE_KEY_TO_TEXT_KEY[AI_TYPE_TO_TOOL_KEY[item.type]],
                        toolKey: AI_TYPE_TO_TOOL_KEY[item.type],
                    });
                }
                return list;
            }
            return false;
        } catch (error) {
            return false;
        }
    },
    getMyCreationsDetailList: async (toolKey, options) => {
        try {
            const eventType = AI_KEY_TO_AI_TYPE[toolKey];
            const { data, code } = await FJNetworkStore.getAITaskList(eventType, {
                ...options,
            });
            if (code === 200) {
                const list = await _parseMyCreations(data.list, FJConstant.MY_CREATIONS_DETAIL_WORK);
                return {
                    list,
                    hasMore: data.list.length === options.pageSize,
                };
            }
        } catch (error) {
            return false;
        }
        return false;
    },
    getSharedCreationsList: async (options = {}) => {
        try {
            const list = await FJNetworkStore.getShareList(options);
            if (!list) return false;
            return {
                list: await _parseCommunityWorkList(list, FJConstant.SHARED_WORK),
                hasMore: list.length === options.limit,
            };
        } catch (error) {
            return false;
        }
    },
    getMyLikeList: async (options = {}) => {
        try {
            const list = await FJNetworkStore.getLikeList(options);
            if (!list) return false;
            return {
                list: await _parseCommunityWorkList(list, FJConstant.LIKE_WORK),
                hasMore: list.length === options.limit,
            };
        } catch (error) {
            return false;
        }
    },
    getAdvertisingList: async () => {
        const list = await FJNetworkStore.getAdvertisement();
        if (!list) return false;
        return list;
    },
    getUserInfo: async (userKey = '') => {
        try {
            if (!userKey) {
                return false;
            }
            const data = await FJNetworkStore.getUserInfo(userKey);
            if (data.avatar || data.username || data.likeNum) {
                return data;
            }
            return false;
        } catch (error) {
            return false;
        }
    },
    setLike: async (id, like) => {
        try {
            const data = await FJNetworkStore.likeWork({ id, like });
            if (data) {
                return data;
            }
            return false;
        } catch (error) {
            return false;
        }
    },

    publishCommunityWork: async (ids, status) => {
        try {
            const data = await FJNetworkStore.publishCommunityWork({ ids, status });
            if (data) {
                return data;
            }
            return false;
        } catch (error) {
            return false;
        }
    },
    deleteWork: async ids => {
        try {
            const data = await FJNetworkStore.deleteTaskList(ids);
            const { code } = data;
            if (code === 200) {
                return true;
            } else if (code === 214) {
                FJUtil.login();
            }
            return false;
        } catch (error) {
            return false;
        }
    },
};

export default FJCommunityStore;
